
























































































import {
  createComponent,
  inject,
  onMounted,
  computed,
  ref,
  SetupContext
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import MemberKey from "@/components/member-key";
import RealTimeTransferKey from "@/components/real-time-transfer-key";
import _ from "lodash";
import { isNullOrEmpty } from "@/methods/validation";

export default createComponent({
  setup(props: {}, context: SetupContext) {
    const displayuiStore = inject(DisplayUIKey);
    if (!displayuiStore) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }
    const memberStore = inject(MemberKey);
    if (!memberStore) {
      throw new Error(`${MemberKey} is not provided`);
    }

    const realTimeTransferStore = inject(RealTimeTransferKey);
    if (!realTimeTransferStore) {
      throw new Error(`${RealTimeTransferKey} is not provided`);
    }

    const globalStore = context.root.$store;
    const loadedFlag = ref<boolean>(false);
    const accessToken = computed(() => globalStore.auth.token);

    const member = computed(() => memberStore.member);

    // 暫定のデータ取得(本来はDBから取得する)
    const bankTransferRequestList = ref<any>([]);

    // 3年分のボタンを表示
    const currentYear = new Date().getFullYear();
    const yearList = _.range(currentYear, currentYear - 3, -1);
    const selectYear = ref(currentYear);

    const slideIndex = ref<number>(0);

    // テーブル
    const bankTransferRequestHeaders = [
      // hide-default-headerが効いていると、widthを指定しても無効となる
      { text: "日時", value: "created_at", align: "center" },
      { text: "ステータス", value: "result", align: "center" },
      { text: "振込金額合計", value: "total_amount", align: "center" }
    ];

    // 振込履歴詳細を表示
    const linkToInformation = (row: any) => {
      realTimeTransferStore.setBankTransferRequestInfos(row);
      context.root.$router.push({
        name: "RealTimeTransferRequestHistoryDetail",
        params: { id: row.id }
      });
    };

    const searchByYear = (year: number) => {
      selectYear.value = year;
      realTimeTransferStore.setSelectedYear(year);
      bankTransferRequestList.value = realTimeTransferStore.searchHistoryByYear(
        year
      );
      return;
    };

    onMounted(async () => {
      loadedFlag.value = true;
      memberStore.setAuthorizationHeader(accessToken.value);
      await memberStore.getMember();
      await realTimeTransferStore.getBankTransferRequestList(
        String(Math.floor(member.value.member_no))
      );
      if (!isNullOrEmpty(realTimeTransferStore.selectedYear)) {
        selectYear.value = realTimeTransferStore.selectedYear;
      }
      searchByYear(selectYear.value);
      loadedFlag.value = false;
    });

    return {
      loadedFlag,
      member,
      bankTransferRequestHeaders,
      bankTransferRequestList,
      yearList,
      selectYear,
      slideIndex,
      searchByYear,
      linkToInformation
    };
  },
  components: {}
});
